export const FETCH_MOVIES_REQUEST = 'FETCH_MOVIES_REQUEST'
export const FETCH_MOVIES_SUCCESS = 'FETCH_MOVIES_SUCCESS'
export const FETCH_MOVIES_FAILURE = 'FETCH_MOVIES_FAILURE'
export const FETCH_MOVIES_SEARCH_REQUEST = 'FETCH_MOVIES_SEARCH_REQUEST'
export const FETCH_MOVIES_SEARCH_SUCCESS = 'FETCH_MOVIES_SEARCH_SUCCESS'
export const FETCH_MOVIES_SEARCH_FAILURE = 'FETCH_MOVIES_SEARCH_FAILURE'